// Capabilities in a given category are mutually exclusive with each other.
export enum CapabilityCategory {
  // Requires requiredWeb3DTools, controls how user navigates.
  Navigation = 'navigation',
  // Adds objects (i.e. markup) on viewer.
  Markup = 'markup',
  // Executes some action (i.e. command) and doesn't interfere with anything.
  Command = 'command',
  // Applies styling to objects.
  Style = 'style',
}
